<template>
  <b-card class="m-0 p-0" no-body>
    <b-card-body class="m-0 p-0">
      <table class="table b-table table-hover table-borderless table-sm">
        <tbody>
          <tr>
            <th class="table-primary b-table-sticky-column position-relative">
              Order's Source
            </th>
            <th
              v-for="day of dates"
              :key="moment(day).toISOString()"
              class="table-primary b-table-sticky-column position-relative"
            >
              {{ moment(day).format("DD/MM/YYYY") }}
            </th>
          </tr>
          <tr v-for="breakdown of reportKeys" :key="breakdown.key">
            <td class="table-b-table-default b-table-sticky-column">
              {{ breakdown.label }}
            </td>
            <td
              v-for="day of dates"
              :key="moment(day).toISOString()"
              class="text-justify"
            >
              ${{ (getCellData(day, breakdown.key).total / 100).toFixed(2) }}
            </td>
          </tr>
          <tr>
            <td class="table-success font-weight-bold">Report Summary</td>
            <td
              class="table-success font-weight-bold"
              v-for="day of dates"
              :key="`${moment(day).toISOString()}-total`"
            >
              ${{ (getTotalCellData(day).total / 100).toFixed(2) }}
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
  </b-card>
</template>

<script>
import * as moment from "moment";
import { getProductTotalCost } from "@/utils/orders/formulas";

export default {
  name: "cash-up",
  props: ["report"],
  data: () => ({
    reportKeys: [
      {
        label: "EFTPOS",
        key: "EFTPOSOrders",
      },
      {
        label: "Cash",
        key: "cashOrders",
      },
      {
        label: "Online",
        key: "webOrders",
      },
    ],
  }),
  computed: {
    dates() {
      let currDate = moment(this.report.startDate, "DD-MM-YYYY").startOf("day");
      let lastDate = moment(this.report.endDate, "DD-MM-YYYY").endOf("day");

      let dates = [currDate.toDate()];
      while (currDate.add(1, "days").diff(lastDate) < 1) {
        dates.push(currDate.clone().toDate());
      }

      return dates;
    },
  },
  methods: {
    moment,
    getCellData(date, key) {
      let filteredOrders = this.report.data[key].filter((o) => {
        return moment(o.createdAt).isSame(moment(date), "day");
      });

      let total = filteredOrders.reduce((sum, next) => {
        return sum + next.total;
      }, 0);

      return { total };
    },
    getTotalCellData(date) {
      let total = 0;
      for (let key of Object.keys(this.report.data)) {
        let filteredOrders = this.report.data[key].filter((o) => {
          return moment(o.createdAt).isSame(moment(date), "day");
        });

        total += filteredOrders.reduce((sum, next) => {
          return sum + next.total;
        }, 0);
      }

      return { total };
    },
    getTotalReportCellData() {
      let filteredLineItems = this.report.data.map((o) => o.lineItems).flat(1);
      let stock = filteredLineItems.reduce((sum, next) => {
        return sum + next.quantity;
      }, 0);
      let total = filteredLineItems.reduce((sum, next) => {
        return sum + getProductTotalCost(next);
      }, 0);

      return { items: stock, total };
    },
    getCSVData() {
      let csvContent =
        "Order's Source ," +
        this.dates.map((d) => moment(d).format("DD/MM/YYYY")).join(",") +
        "\r\n";
      for (let breakdown of this.reportKeys) {
        csvContent += `"${breakdown.label}"`;
        for (let day of this.dates) {
          const cellData = this.getCellData(day, breakdown.key);
          csvContent += `, $${(cellData.total / 100).toFixed(2)}`;
        }
        csvContent += "\r\n";
      }
      csvContent += "Report Summary";
      for (let day of this.dates) {
        const dailyTotal = this.getTotalCellData(day);
        csvContent += `,$${(dailyTotal.total / 100).toFixed(2)}`;
      }

      return csvContent;
    },
  },
};
</script>

<style scoped></style>
